import React from 'react';
import { Redirect } from 'react-router-dom';
import { AuthContext, AuthContextType, ServicesContext } from '~/services';

export function Logout() {
    const { user } = React.useContext(ServicesContext);
    const { authenticated } = React.useContext(AuthContext) as AuthContextType;
    React.useEffect(() => {
        (async () => {
            await user.logout();
        })();
    }, [user]);

    // Make sure to stay on the blank page until logout completes
    return React.useMemo(() => {
        return authenticated ? null : <Redirect to="/" />;
    }, [authenticated]);
}
